import { useEffect, useState } from "react";
import {
  clearAuthStorage,
  getStoredUser,
  setStoredUser,
  syncAuthFromOtherTabs,
} from "auth/authStorage";

function UseProvideAuth() {

  // *For User
  const [user, setUser] = useState(getStoredUser());
  const [isAuthBootstrapping, setIsAuthBootstrapping] = useState(!getStoredUser());

  useEffect(() => {
    let cancelled = false;

    const bootstrap = async () => {
      try {
        const already = getStoredUser();
        if (already) {
          if (!cancelled) {
            setUser(already);
            setIsAuthBootstrapping(false);
          }
          return;
        }

        // Try to sync user/session from another already-open tab.
        await syncAuthFromOtherTabs({ timeoutMs: 300 });

        const synced = getStoredUser();
        if (!cancelled) {
          setUser(synced);
          setIsAuthBootstrapping(false);
        }
      } catch {
        if (!cancelled) setIsAuthBootstrapping(false);
      }
    };

    bootstrap();
    return () => {
      cancelled = true;
    };
  }, []);

  // *For Login
  const userLogin = (data) => {
    setStoredUser(data);
    setUser(data)
  };

  // *For Logout
  const userLogout = async () => {
    setUser(null)
    clearAuthStorage();
  };

  return {
    user,
    isAuthBootstrapping,
    userLogin,
    userLogout
  };
}

export default UseProvideAuth;